import React, { Fragment, useState } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { loginEmployer } from "../../../actions/auth";
import { setAlert } from "../../../actions/alert";

import Alert from "../IME/Alert";
import BlueLogo from "./BlueLogo";
import IMEAltLogo from "../IME/IMEAltLogo";

const EmployerLogin = ({ loginEmployer, isAuthenticated, setAlert }) => {
  const [profileDropDown, setprofileDropDown] = useState(false);
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  const { email, password } = formData;

  const onChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    if (email === "") {
      setAlert("Please enter a valid email");
    }
    if (password === "") {
      setAlert("Please enter a password");
    }
    loginEmployer(email, password);
  };

  return (
    <Fragment>
      <nav className="login-nav background-dark-black border-bottom grey">
        <form
          className="main"
          action="/:channelid"
          method="POST"
          onSubmit={(e) => onSubmit(e)}
        >
          <div className="action-items-index">
            <Link to="/">
              <div className="action-button-index blue">
                <i className="fas fa-angle-left action-icon-index-alt fa-lg blue"></i>
              </div>
            </Link>
            <p className="action-text-index blue">Back</p>
          </div>
          <div className="action-items-index">
            <div
              className="action-button-index blue"
              onClick={() => {
                if (!profileDropDown) {
                  setprofileDropDown(true);
                } else {
                  setprofileDropDown(false);
                }
              }}
            >
              <i className="fas fa-user action-icon-index fa-lg blue"></i>
            </div>
            <p className="action-text-index blue">Login</p>
          </div>
          {profileDropDown && (
            <div className="profile-drop-down-alternate">
              <div className="profile-drop-container-nav">
                <div className="label-input">
                  <label htmlFor="email" className="labels blue">
                    *Email:
                  </label>
                  {email === "" && <Alert />}
                  <input
                    name="email"
                    className="input-style-nav"
                    type="email"
                    value={email}
                    placeholder="Enter Email Address"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                </div>
                <div className="label-input">
                  <label htmlFor="password" className="labels blue">
                    *Password:
                  </label>
                  {password === "" && <Alert />}
                  <input
                    name="password"
                    className="input-style-nav"
                    type="password"
                    min={7}
                    maxLength={20}
                    value={password}
                    placeholder="Enter Password"
                    onChange={(e) => onChange(e)}
                    tabIndex="2"
                  />
                  {email !== "" && password !== "" && (
                    <div className="login-button-container-alt">
                      <button
                        className="login-button-alt background-blue"
                        type="submit"
                      >
                        Login
                      </button>
                    </div>
                  )}
                  <Link to="/forgotpassword">
                    <p className="forgot blue bold" tabIndex="4">
                      Forgot Password?
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          )}
        </form>
        <div className="center-nav">
          <div className="index-logo-alt">
            <BlueLogo />
          </div>
          <i className="fas fa-trademark blue fa-sm mt-10"></i>
          <div className="index-logo">
            <IMEAltLogo />
          </div>
        </div>
      </nav>
    </Fragment>
  );
};

EmployerLogin.propTypes = (state) => ({
  loginEmployer: PropTypes.func.isRequired,
  setAlert: PropTypes.func.isRequired,
});

const mapStateToProps = (state) => ({
  isAuthenticated: state.auth.isAuthenticated,
  redirected: state.auth.redirected,
});

export default connect(mapStateToProps, { loginEmployer, setAlert })(
  EmployerLogin
);
